import { colors } from '@material-ui/core';


export const createData = (openOccurrencesData, solvedOccurrencesData, label) => {

    return {
        datasets: [
            {
                backgroundColor: colors.blue[900],
                barPercentage: 0.5,
                barThickness: 12,
                borderRadius: 4,
                categoryPercentage: 0.5,
                data: openOccurrencesData,
                label: 'Ocorrências abertas',
                maxBarThickness: 10
            },
            {
                backgroundColor: colors.orange[500],
                barPercentage: 0.5,
                barThickness: 12,
                borderRadius: 4,
                categoryPercentage: 0.5,
                data: solvedOccurrencesData,
                label: 'Ocorrências atendidas',
                maxBarThickness: 10
            }
        ],
        labels: label
    };
}

export const getOptionsToGraph = () => {
    return {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
            },
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };
}